import { Calendar, Phone, Mail } from "lucide-react";
import { motion } from "framer-motion";
import { DIVISIONS, COMPANY } from "../lib/divisions";

const SchedulePage = () => (
  <div className="pt-32 pb-24 bg-white min-h-screen">
    <div className="max-w-4xl mx-auto px-6 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center"
      >
        <div className="h-[3px] w-14 bg-[#C89B3C] mx-auto mb-6" />
        <span className="text-xs font-medium tracking-[0.2em] uppercase text-slate-500 mb-3 block">
          Schedule
        </span>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-[#0B2343] leading-tight mb-6">
          Book Your Free Consultation
        </h1>
        <p className="text-lg text-slate-600 mb-10 max-w-2xl mx-auto">
          Pick a time that works for you. No obligation, no pressure — just a straightforward
          conversation about how we can help.
        </p>

        <a
          href={COMPANY.scheduleUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="schedule-google-cta"
          className="inline-flex items-center gap-3 bg-[#0B2343] text-white px-10 py-5 font-medium tracking-wide hover:bg-slate-800 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5"
        >
          <Calendar size={22} />
          Open Calendar & Book Now
        </a>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16 pt-16 border-t border-slate-200 text-left">
          {Object.values(DIVISIONS).map((d) => (
            <div key={d.id} className="p-6 bg-slate-50 border-l-4 border-[#C89B3C]">
              <h3 className="font-serif font-bold text-slate-900 mb-3">{d.shortName}</h3>
              <a
                href={d.phoneHref}
                className="flex items-center gap-2 text-sm text-slate-700 hover:text-[#C89B3C] mb-2"
              >
                <Phone size={14} className="text-[#C89B3C]" />
                {d.phone}
              </a>
              <a
                href={`mailto:${d.email}`}
                className="flex items-center gap-2 text-sm text-slate-700 hover:text-[#C89B3C] break-all"
              >
                <Mail size={14} className="text-[#C89B3C] flex-shrink-0" />
                <span className="truncate">{d.email}</span>
              </a>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </div>
);

export default SchedulePage;
